export const ADD_TO_CART = 'app/Containers/Cart/ADD_TO_CART'
export const REMOVE_FROM_CART = 'app/Containers/Cart/REMOVE_FROM_CART'

export const CHANGE_CART = 'app/Containers/Cart/PLUS_CART'
export const MINUS_CART = 'app/Containers/Cart/MINUS_CART'

export const REFRESH_CART = 'app/Containers/Cart/REFRESH_CART'


